import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {css} from "@panda/css";

import {SearchBoldIcon} from "@pg-design/icons-module";
import {InputCore, InputWrapper} from "@pg-design/inputs-module";
import {NAVIGATION_MOBILE_TEST_IDS, NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../../app/rp_reducer";
import {Country} from "../../../region/types/Country";
import {updateCurrentTab} from "../../../search/actions/update_current_tab";
import {SearchTab} from "../../../search/types/SearchTab";

interface IProps {
    onClick: () => void;
}

export const HomepageLegacyMobileSearchPlaceholder = (props: IProps) => {
    const search = useSelector((state: IRPStore) => state.search);
    const dispatch = useDispatch();
    const isPolandTabActive = search.currentTabData.currentTab === SearchTab.Regions && search.currentTabData.country === Country.POLAND;
    const isSpainTabActive = search.currentTabData.currentTab === SearchTab.Regions && search.currentTabData.country === Country.SPAIN;
    const isHolidayTabActive = search.currentTabData.currentTab === SearchTab.Holiday;

    const isAbroadOrHolidayTab = isHolidayTabActive || search.currentTabData.country === Country.SPAIN;
    const inputPlaceholder = isAbroadOrHolidayTab ? "Wybierz lokalizację" : "Gdzie chcesz mieszkać?";

    return (
        <div className={legacyWrapperStyle}>
            <div className={tabsWrapperStyle} data-testid={NAVIGATION_TEST_IDS.SEARCH_BAR.COUNTRY_TAB}>
                <button
                    type="button"
                    onClick={() => dispatch(updateCurrentTab(SearchTab.Regions, Country.POLAND))}
                    className={tabStyle}
                    data-active={isPolandTabActive}
                >
                    W Polsce
                </button>
                <button
                    type="button"
                    onClick={() => dispatch(updateCurrentTab(SearchTab.Regions, Country.SPAIN))}
                    className={tabStyle}
                    data-active={isSpainTabActive}
                >
                    W Hiszpanii
                </button>
                <button type="button" onClick={() => dispatch(updateCurrentTab(SearchTab.Holiday))} className={tabStyle} data-active={isHolidayTabActive}>
                    Wakacyjne
                </button>
            </div>
            <div className={legacyPlaceholderStyle} onClick={props.onClick}>
                <div className={legacyIconWrapperStyle}>
                    <SearchBoldIcon size="2.4" />
                </div>

                <InputWrapper className={legacyInputWrapperStyle}>
                    <InputCore placeholder={inputPlaceholder} readOnly dataTestId={NAVIGATION_MOBILE_TEST_IDS.SEARCH_BAR.INPUT} />
                </InputWrapper>
            </div>
        </div>
    );
};

const legacyWrapperStyle = css({
    display: "flex",
    maxWidth: "552px",
    width: "calc(100% - 3.2rem)",
    flexDirection: "column",
    borderRadius: 2,
    overflow: "hidden"
});

const legacyPlaceholderStyle = css({
    cursor: "pointer",
    position: "relative",
    display: "flex",
    height: "50px",
    backgroundColor: "#fff"
});

const legacyIconWrapperStyle = css({
    flex: "0 0 auto",
    cursor: "text",
    zIndex: 1,
    height: "100%",
    width: "6.4rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "var(--colors-primary)"
});

const legacyInputWrapperStyle = css({
    height: "50px",
    pl: 2,
    pr: 3,
    width: "100%",
    border: 0,
    borderRadius: 0,

    "&:focus": {
        outline: "none"
    },

    "& input": {
        fontSize: "1.6rem"
    }
});

const tabsWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    backgroundColor: "var(--colors-gray-200)",
    overflow: "hidden",
    maxHeight: "4.8rem"
});

const tabStyle = css({
    width: "100%",
    height: "4.8rem",
    border: 0,
    borderRadius: 0,
    backgroundColor: "var(--colors-background-100)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",

    "&[data-active='true']": {
        backgroundColor: "var(--colors-background-200)"
    },

    _hover: {
        backgroundColor: "var(--colors-background-200)"
    }
});
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {css} from "@panda/css";

import {SearchBoldIcon} from "@pg-design/icons-module";
import {InputCore, InputWrapper} from "@pg-design/inputs-module";
import {NAVIGATION_MOBILE_TEST_IDS, NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../../app/rp_reducer";
import {Country} from "../../../region/types/Country";
import {updateCurrentTab} from "../../../search/actions/update_current_tab";
import {SearchTab} from "../../../search/types/SearchTab";

interface IProps {
    onClick: () => void;
}

export const HomepageLegacyMobileSearchPlaceholder = (props: IProps) => {
    const search = useSelector((state: IRPStore) => state.search);
    const dispatch = useDispatch();
    const isPolandTabActive = search.currentTabData.currentTab === SearchTab.Regions && search.currentTabData.country === Country.POLAND;
    const isSpainTabActive = search.currentTabData.currentTab === SearchTab.Regions && search.currentTabData.country === Country.SPAIN;
    const isHolidayTabActive = search.currentTabData.currentTab === SearchTab.Holiday;

    const isAbroadOrHolidayTab = isHolidayTabActive || search.currentTabData.country === Country.SPAIN;
    const inputPlaceholder = isAbroadOrHolidayTab ? "Wybierz lokalizację" : "Gdzie chcesz mieszkać?";

    return (
        <div className={legacyWrapperStyle}>
            <div className={tabsWrapperStyle} data-testid={NAVIGATION_TEST_IDS.SEARCH_BAR.COUNTRY_TAB}>
                <button
                    type="button"
                    onClick={() => dispatch(updateCurrentTab(SearchTab.Regions, Country.POLAND))}
                    className={tabStyle}
                    data-active={isPolandTabActive}
                >
                    W Polsce
                </button>
                <button
                    type="button"
                    onClick={() => dispatch(updateCurrentTab(SearchTab.Regions, Country.SPAIN))}
                    className={tabStyle}
                    data-active={isSpainTabActive}
                >
                    W Hiszpanii
                </button>
                <button type="button" onClick={() => dispatch(updateCurrentTab(SearchTab.Holiday))} className={tabStyle} data-active={isHolidayTabActive}>
                    Wakacyjne
                </button>
            </div>
            <div className={legacyPlaceholderStyle} onClick={props.onClick}>
                <div className={legacyIconWrapperStyle}>
                    <SearchBoldIcon size="2.4" />
                </div>

                <InputWrapper className={legacyInputWrapperStyle}>
                    <InputCore placeholder={inputPlaceholder} readOnly dataTestId={NAVIGATION_MOBILE_TEST_IDS.SEARCH_BAR.INPUT} />
                </InputWrapper>
            </div>
        </div>
    );
};

const legacyWrapperStyle = css({
    display: "flex",
    maxWidth: "552px",
    width: "calc(100% - 3.2rem)",
    flexDirection: "column",
    borderRadius: 2,
    overflow: "hidden"
});

const legacyPlaceholderStyle = css({
    cursor: "pointer",
    position: "relative",
    display: "flex",
    height: "50px",
    backgroundColor: "#fff"
});

const legacyIconWrapperStyle = css({
    flex: "0 0 auto",
    cursor: "text",
    zIndex: 1,
    height: "100%",
    width: "6.4rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "var(--colors-primary)"
});

const legacyInputWrapperStyle = css({
    height: "50px",
    pl: 2,
    pr: 3,
    width: "100%",
    border: 0,
    borderRadius: 0,

    "&:focus": {
        outline: "none"
    },

    "& input": {
        fontSize: "1.6rem"
    }
});

const tabsWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    backgroundColor: "var(--colors-gray-200)",
    overflow: "hidden",
    maxHeight: "4.8rem"
});

const tabStyle = css({
    width: "100%",
    height: "4.8rem",
    border: 0,
    borderRadius: 0,
    backgroundColor: "var(--colors-background-100)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",

    "&[data-active='true']": {
        backgroundColor: "var(--colors-background-200)"
    },

    _hover: {
        backgroundColor: "var(--colors-background-200)"
    }
});
